import {configureStore} from '@reduxjs/toolkit';

import {backendApi} from './app/api/backendApi';
import rootReducer from './reducers';

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({serializableCheck: false}).concat(
      backendApi.middleware
    ),
  devTools: process.env.NODE_ENV !== 'production',
});

export type ReduxState = ReturnType<typeof store.getState>;
export type ReduxDispatch = typeof store.dispatch;
